module.exports = __webpack_public_path__ + "img/login.834aa7bb.svg";